import React, { FC } from 'react';
import { Box, CircularProgress } from '@mui/material';

const PreloaderComponent: FC = () => (
  // <PreloaderWrapper data-testid="PreloaderComponent"> Preloader Component </PreloaderWrapper>

  <Box
    data-testid="PreloaderComponent"
    sx={{
      width: 100,
      height: 100,
      position: 'fixed',
      top: '50%',
      left: '50%',
    }}
  >
    <CircularProgress size={50} color="primary" />
  </Box>
);

export default PreloaderComponent;
